module.exports = __webpack_public_path__ + "static/media/logo.dec569fd.png";